import { useNavigate } from '@tanstack/react-router';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { SitesList } from '@frontend/wam-views';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  const navigate = useNavigate();

  const handleSiteDetailsClick = (siteName: string) => {
    navigate({
      to: '/global-settings/releases/$siteName' as any,
      params: { siteName } as any,
    });
  };

  return (
    <Page
      title='Release Management'
      breadcrumbs={[
        {
          label: 'Global Settings',
          to: '/global-settings',
        },
        {
          label: 'Web Releases',
        },
      ]}
    >
      <Container>
        <SitesList onSiteDetailsClick={handleSiteDetailsClick} />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/releases',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
  requiredAcl: [Permission.APP_RELEASE_WRITE],
  acls: [Permission.APP_RELEASE_WRITE],
});
